// Module
var code = "<a href=\"javascript:;\" class=\"text-sm sps-btn sps-btn-outline btn-color-dashboard-screen\"> <i class=\"fa fa-columns\" align=\"center\"></i> <!-- ko text: _labels.DASHBOARD --><!-- /ko --> </a>";
// Exports
export default code;